<footer class="footer">
    <div class="footer-container">
        <div style="flex: 1;">
            <div class="footer-lg">Contact Us</div>
            <div class="footer-sm"><img class="footer-icon" src="assets/img/icons/hotline.svg" alt="">Hotline: 1622-7226</div>
            <div class="footer-sm"><img class="footer-icon" src="assets/img/icons/email.svg" alt="">contactus&#64;peccbm.ph</div>
        </div>
        <div class="about-us">
            <div class="footer-sm">
                <a class="footer-link " href="/about">About Us</a>
            </div>
            <div class="footer-sm">
                <a class="footer-link " href="/about#contractors" target="_blank">List of Contractors</a>
            </div>
            <div class="footer-sm">
                <a class="footer-link " href="/terms" target="_blank">Terms and Conditions</a>
            </div>
        </div>
    </div>
</footer>
